module.exports = __webpack_public_path__ + "img/1574536641.20ec36f6.jpg";